export default function Footer({ contact = true }) {

    return (
        <>
            <footer
                className="bg-dark-gray background-position-center-top"
                style={{ backgroundImage: "url('images/demo-decor-store-footer-bg.jpg')" }}
            >

                {
                    contact &&
                    <div className="container overlap-section">
                        <div className="row g-0  justify-content-center align-items-center bg-base-color border-radius-6px ps-7 pe-7 pt-4 pb-4 lg-p-30px sm-p-20px mb-7 contact-cardsz">
                            <div className="col-lg-6 col-md-9 text-center text-lg-start md-mb-20px">
                                <h4 className="text-white fw-600 mb-0 ls-minus-1px">¡Hablemos sobre cómo podemos ayudarte a comprar el auto ideal!</h4>
                            </div>
                            <div className="col-auto col-lg-5 icon-with-text-style-08 offset-lg-1">
                                <div className="feature-box feature-box-left-icon-middle overflow-hidden">
                                    <div className="feature-box-icon feature-box-icon-rounded w-80px h-80px rounded-circle bg-dark-gray-transparent-light me-25px lg-me-20px">
                                        <i className="bi bi-envelope icon-very-medium text-white"></i>
                                    </div>
                                    <div className="feature-box-content last-paragraph-no-margin">
                                        <span className="text-white fs-18 lh-22 mb-5px d-block">¿Te interesa cotizar tu carro ideal? ¡Estoy para ayudarte!</span>
                                        <h6 className="d-inline-block fw-600 mb-0"><a href="mailto:info@saag.mx" className="text-dark-gray text-decoration-line-bottom-medium text-white-hover">info@saag.mx</a></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="container footer-dark text-center text-sm-start">
                    <div className="row mb-5 sm-mb-30px">

                        <div className="col-lg-3 col-md-4 col-sm-6 d-flex flex-column last-paragraph-no-margin md-mb-35px">
                            <a href="#" className="footer-logo mb-25px xs-mb-20px d-inline-block">
                                <img src="/images/SAAG/BESTUNE logo blanco.png" data-at2x="public/images/SAAG/BESTUNE logo blanco.png" alt="" />
                            </a>

                            <div className="row">
                                {/* BESTUNE */}
                                <div className="col-12 col-md-6">
                                    <div className="elements-social social-text-style-01 mt-auto">
                                        <p>BESTUNE</p>
                                        <ul className="small-icon light fw-500">
                                            <li>
                                                <a className="facebook" href="https://www.facebook.com/Bestunemx/" target="_blank">
                                                    <i className="bi bi-facebook text-white align-middle"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a className="instagram" href="https://www.instagram.com/bestunemx/" target="_blank">
                                                    <i className="bi bi-instagram text-white align-middle"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a className="tiktok" href="https://www.tiktok.com/@bestunemx" target="_blank">
                                                    <i className="bi bi-tiktok text-white align-middle"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {/* JIM */}
                                <div className="col-12 col-md-6">
                                    <div className="elements-social social-text-style-01 mt-auto">
                                        <p>JIM</p>
                                        <ul className="small-icon light fw-500">
                                            <li>
                                                <a className="facebook" href="https://www.facebook.com/JIMoficialmx" target="_blank">
                                                    <i className="bi bi-facebook text-white align-middle"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a className="instagram" href="https://www.instagram.com/jim_oficialmx/" target="_blank">
                                                    <i className="bi bi-instagram text-white align-middle"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a className="tiktok" href="https://www.tiktok.com/@jim.oficialmx" target="_blank">
                                                    <i className="bi bi-tiktok text-white align-middle"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div className="col-lg-5 col-md-4 col-sm-6 last-paragraph-no-margin md-mb-35px">
                            <p className="w-90 lg-w-95 xs-w-60 xs-mx-auto mb-10px text-white ">
                                BESTUNE, cuenta con una amplia experiencia y ejecución en el sector automotriz internacional tanto comercial como de ingeniería y manufactura.
                            </p>
                        </div>




                    </div>
                    <div className="row align-items-center footer-bottom border-top border-color-transparent-white-light pt-30px g-0">
                        <div className="col-lg-8 ps-0 text-center text-lg-start md-mb-10px">
                            
                        </div>

                        <div className="col-lg-4 last-paragraph-no-margin text-center text-lg-end">
                            <p className="fs-15">&copy; Copyright © 2025 saag.mx – Creado por
                            </p>
                            <span className="text-white">
                                <a
                                    href="https://codeglider.com.mx/"
                                    target="_blank"
                                    className="text-white text-decoration-line-bottom"
                                >
                                    CodeGlider
                                </a>
                                {" "}–{" "}
                                <a
                                    href="https://arescode.com.mx/"
                                    target="_blank"
                                    className="text-white text-decoration-line-bottom"
                                >
                                    AresCode
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="scroll-progress d-none d-xxl-block">
                <a href="#" className="scroll-top" aria-label="scroll">
                    <span className="scroll-text">
                        <i className="bi bi-arrow-down text-white align-middle fs-4"></i>
                    </span>
                    <span className="scroll-line">
                        <span className="scroll-point"></span>
                    </span>
                </a>
            </div>
        </>
    );
}